import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { supabase } from "./supabaseClient"

export default function PaymentGuard({ children }) {
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState(null)
  const [plan, setPlan] = useState(null)
  const [error, setError] = useState(null)
  const [retryingPayment, setRetryingPayment] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const checkStatus = async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) {
        navigate("/login")
        return
      }
      const { data: user } = await supabase
        .from("users")
        .select("status, plan")
        .eq("id", session.user.id)
        .single()
      if (user) {
        setStatus(user.status)
        setPlan(user.plan)
      }
      setLoading(false)
    }
    checkStatus()
  }, [navigate])

  async function reintentarPago() {
    setError(null)
    setRetryingPayment(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(process.env.REACT_APP_API_URL + "/api/create-checkout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${session?.access_token}`
        },
        body: JSON.stringify({ plan: plan || "starter" })
      })
      const data = await res.json()
      if (!res.ok || !data.url) {
        setError("No se pudo iniciar el pago")
        setRetryingPayment(false)
        return
      }
      window.location.href = data.url
    } catch (e) {
      setError("No se pudo conectar con el servidor")
      setRetryingPayment(false)
    }
  }

  async function cerrarSesion() {
    await supabase.auth.signOut()
    navigate("/login")
  }

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Inter, sans-serif", color: "#666" }}>
        Cargando...
      </div>
    )
  }

  if (status !== "active" && status !== "cancelling") {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#fafafa", fontFamily: "Inter, sans-serif", padding: "2rem" }}>
        <div style={{ maxWidth: 480, width: "100%", background: "white", borderRadius: 16, padding: "2.5rem", boxShadow: "0 4px 24px rgba(0,0,0,.06)", border: "1px solid #eee", textAlign: "center" }}>
          <div style={{ fontSize: 48, marginBottom: "1rem" }}>🔒</div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: "#1a1a1a", marginBottom: ".75rem", fontFamily: "Inter, sans-serif" }}>
            Termina tu pago para continuar
          </h1>
          <p style={{ fontSize: 14, color: "#666", marginBottom: "2rem", lineHeight: 1.5 }}>
            Tu cuenta esta creada pero aun no se ha confirmado el pago. Completa tu suscripcion para acceder a KORIVA Studio.
          </p>
          {error && (
            <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 8, padding: "8px 12px", fontSize: 12, color: "#DC2626", marginBottom: "1rem" }}>
              {error}
            </div>
          )}
          <button
            onClick={reintentarPago}
            disabled={retryingPayment}
            style={{
              width: "100%",
              padding: "14px",
              background: "#6D28D9",
              color: "white",
              border: "none",
              borderRadius: 10,
              fontSize: 14,
              fontWeight: 700,
              cursor: retryingPayment ? "wait" : "pointer",
              marginBottom: ".75rem",
              opacity: retryingPayment ? 0.7 : 1
            }}
          >
            {retryingPayment ? "Redirigiendo a Stripe..." : "Continuar al pago →"}
          </button>
          <button
            onClick={cerrarSesion}
            style={{
              width: "100%",
              padding: "10px",
              background: "transparent",
              color: "#666",
              border: "none",
              fontSize: 13,
              cursor: "pointer"
            }}
          >
            Cerrar sesion
          </button>
        </div>
      </div>
    )
  }

  return children
}
